import React, { useState, useEffect } from "react";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import localization from "assets/localization/localization";
import Regex from "services/utils/regex/Regex";

const GoLiveFilterForm = ({
  applyFilter,
  siteTypes=[],
  // assignedAreas=[],
  reportees=[],
}) => {
  const filterInputs = {
    site_no: "",
    client_name: "",
    site_type: "",
    // area_id: "",
    assignee_ids: "",
    commercial_type_id:'',
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
  const [listStatus, setListStatus] = useState("");


  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(
        localStorage.getItem("applyFilter") &&
          localStorage.getItem("applyFilter")
      );
      const status = await JSON.parse(
        localStorage.getItem("statusFilter") &&
          localStorage.getItem("statusFilter")
      );
      if (roles && status) {
        setFilterFieldsData(roles);
        setListStatus(status);
      }
    })();
  }, []);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
        filterFieldsData && localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
        listStatus && localStorage.setItem("statusFilter", JSON.stringify(listStatus));
      }}
    >
      <ConstantInput
        label={localization.siteNumber}
        value={filterFieldsData.site_no}
        regex={Regex.alphaNum.test(filterFieldsData.site_no)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, site_no: val })
        }
      />
      <ConstantInput
        label={localization.clientName}
        value={filterFieldsData.client_name}
        regex={Regex.text.test(filterFieldsData.client_name)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, client_name: val })
        }
      />

      <DropDownInput
        disabled={siteTypes.length === 0}
        label={localization.siteType}
        data={siteTypes}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, site_type: val.id })
        }
      />
      {/* <DropDownInput
        disabled={assignedAreas.length === 0}
        label={localization.assignedArea}
        data={assignedAreas}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, assigned_area: val.id })
        }
      /> */}
      <DropDownInput
        disabled={reportees.length === 0}
        label={localization.assignee}
        data={reportees}
        getIdValue={(val) =>
          setFilterFieldsData({ ...filterFieldsData, assignee_ids: val.id })
        }
      />

      <DropDownInput
          label={localization.commercialType}
          data={[
            {id: 5, name: "Capex",},
            {id: 6, name: "Opex-Ownership",},
            {id: 7, name: "Rental",},
          ]}
          getIdValue={(val) =>{
            setFilterFieldsData({
              ...filterFieldsData,
              commercial_type_id: val.id,
            })
          }
          }
      />
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br/>
        <br/>
        <button
          onClick={() => {
            localStorage.setItem("applyFilter", JSON.stringify(filterInputs));
            applyFilter(filterInputs);
            localStorage.setItem("statusFilter", JSON.stringify({}));
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default GoLiveFilterForm;
